module.exports = __webpack_public_path__ + "static/media/b3_p6_clickable_b_ph.80595bb5.png";